var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06287 6.24663C2.06287 5.30492 2.82628 4.5415 3.76799 4.5415H10.5885C11.5302 4.5415 12.2936 5.30492 12.2936 6.24663V13.0671C12.2936 14.0089 11.5302 14.7723 10.5885 14.7723H3.76799C2.82628 14.7723 2.06287 14.0089 2.06287 13.0671V6.24663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2936 8.52014L15.8704 4.94341C16.2284 4.58535 16.8406 4.83894 16.8406 5.34531V13.9685C16.8406 14.4748 16.2284 14.7284 15.8704 14.3704L12.2936 10.7936M3.768 14.7723H10.5885C11.5302 14.7723 12.2936 14.0089 12.2936 13.0671V6.24663C12.2936 5.30492 11.5302 4.5415 10.5885 4.5415H3.76799C2.82628 4.5415 2.06287 5.30492 2.06287 6.24663V13.0671C2.06287 14.0089 2.82628 14.7723 3.768 14.7723Z",
    stroke: "white",
    strokeWidth: 1.13675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.9912cccda3e05d8f2399d08d477a37c3.svg";
export { ForwardRef as ReactComponent };